import axios from 'axios';

export default function() {
  const csrfToken = document.querySelector("meta[name=csrf-token]") && document.querySelector("meta[name=csrf-token]").content;
  axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
  axios.defaults.headers.common['Content-Type'] = 'application/json';
}
